import { p } from "./_helpers";

const immobilier = {
 slug: "immobilier",
 path: "/secteurs/immobilier",
 hero: {
 image: "/photos/sector-immobilier-hero.jpg",
 alt: p("Immobilier commercial moderne en Guinée-Bissau", "Modern commercial real estate in Guinea-Bissau", "Imobiliário comercial moderno na Guiné-Bissau"),
 breadcrumb: p("Immobilier", "Real estate", "Imobiliário"),
 title: p("Investir dans l'immobilier.", "Investing in real estate.", "Investir no imobiliário."),
 subtitle: p(
 "Commerces, entrepôts logistiques, logements et hôtellerie : des marchés urbains émergents à Bissau et Canchungo.",
 "Retail, logistics warehouses, housing and hospitality: emerging urban markets in Bissau and Canchungo.",
 "Comércios, armazéns logísticos, habitação e hotelaria: mercados urbanos emergentes em Bissau e Canchungo."
 ),
 },
 seo: {
 title: p(
 "Investir dans l'immobilier en Guinée-Bissau | NANDA SÁ",
 "Investing in real estate in Guinea-Bissau | NANDA SÁ",
 "Investir no imobiliário na Guiné-Bissau | NANDA SÁ"
 ),
 description: p(
 "Panorama immobilier en Guinée-Bissau : commerces, entrepôts, logements, hôtellerie à Bissau et Canchungo. Chiffres clés, opportunités, défis et passerelles NANDA SÁ.",
 "Real estate panorama in Guinea-Bissau: retail, warehouses, housing, hospitality in Bissau and Canchungo. Key figures, opportunities, challenges and NANDA SÁ pathways.",
 "Panorama imobiliário na Guiné-Bissau: comércios, armazéns, habitação, hotelaria em Bissau e Canchungo. Dados-chave, oportunidades, desafios e pontes NANDA SÁ."
 ),
 keywords: "immobilier Guinée-Bissau, entrepôts Bissau, logements Canchungo, foncier commercial, real estate West Africa",
 },
 presentation: {
 title: p("Un marché immobilier en train de naître.", "A real estate market in the making.", "Um mercado imobiliário em formação."),
 paragraphs: p(
 [
 "Bissau compte environ 500 000 habitants, Canchungo entre 15 000 et 25 000. Ces marchés urbains, encore modestes, connaissent une croissance démographique et une urbanisation soutenues. Les besoins en surfaces commerciales, en entrepôts logistiques, en logements pour la classe moyenne émergente et en hôtellerie de milieu de gamme sont considérables et largement non couverts.",
 "Contrairement aux capitales saturées de la région (Abidjan), le foncier reste accessible, les prix bas et les marges intéressantes. C'est le moment de se positionner sur un cycle long.",
 ],
 [
 "Bissau has about 500,000 inhabitants, Canchungo between 15,000 and 25,000. These still modest urban markets are experiencing sustained demographic growth and urbanisation. Needs for retail space, logistics warehouses, housing for the emerging middle class and mid-range hospitality are considerable and largely unmet.",
 "Unlike the saturated capitals of the region (Abidjan), land remains accessible, prices low and margins attractive. This is the moment to position oneself for a long cycle.",
 ],
 [
 "Bissau tem cerca de 500 000 habitantes, Canchungo entre 15 000 e 25 000. Estes mercados urbanos, ainda modestos, conhecem um crescimento demográfico e uma urbanização sustentados. As necessidades em superfícies comerciais, armazéns logísticos, habitação para a classe média emergente e hotelaria de gama média são consideráveis e largamente por cobrir.",
 "Ao contrário das capitais saturadas da região (Bissau, Abidjan), o solo permanece acessível, os preços baixos e as margens interessantes. É o momento de se posicionar num ciclo longo.",
 ]
 ),
 },
 kpis: {
 title: p("Chiffres clés du marché", "Market key figures", "Dados-chave do mercado"),
 items: [
 { n: "~500k", l: p("Habitants à Bissau", "Bissau inhabitants", "Habitantes em Bissau"), d: p("Croissance urbaine soutenue.", "Sustained urban growth.", "Crescimento urbano sustentado.") },
 { n: "3-4 %", l: p("Croissance annuelle urbaine", "Annual urban growth", "Crescimento urbano anual"), d: p("Rythme comparable à celui de la sous-région.", "Rate comparable to sub-region.", "Ritmo comparável ao da sub-região.") },
 { n: "10x", l: p("Différentiel de prix foncier vs Bissau", "Land price differential vs Bissau", "Diferencial de preço fundiário vs Bissau"), d: p("Fenêtre d'entrée avant appréciation.", "Entry window before appreciation.", "Janela de entrada antes da valorização.") },
 { n: "60 %", l: p("Population < 25 ans", "Population < 25 years", "População < 25 anos"), d: p("Formation naturelle de nouveaux foyers.", "Natural formation of new households.", "Formação natural de novos agregados.") },
 { n: "Rare", l: p("Hôtellerie milieu de gamme", "Mid-range hospitality", "Hotelaria de gama média"), d: p("Offre inférieure à la demande.", "Supply below demand.", "Oferta abaixo da procura.") },
 { n: "Forte", l: p("Demande d'entrepôts certifiés", "Demand for certified warehouses", "Procura de armazéns certificados"), d: p("Filière cajou et importateurs en attente.", "Cashew sector and importers awaiting.", "Fileira do caju e importadores à espera.") },
 ],
 sources: p(
 "Sources : ONU-Habitat, Banque mondiale, INE Guinée-Bissau, estimations sectorielles NANDA SÁ 2024-2025.",
 "Sources: UN-Habitat, World Bank, INE Guinea-Bissau, NANDA SÁ sector estimates 2024-2025.",
 "Fontes: ONU-Habitat, Banco Mundial, INE Guiné-Bissau, estimativas sectoriais NANDA SÁ 2024-2025."
 ),
 },
 opportunites: {
 title: p("Segments d'investissement prioritaires", "Priority investment segments", "Segmentos de investimento prioritários"),
 intro: p(
 "Quatre segments distincts, chacun avec son horizon et son intensité capitalistique.",
 "Four distinct segments, each with its horizon and capital intensity.",
 "Quatro segmentos distintos, cada um com o seu horizonte e intensidade capitalística."
 ),
 segments: [
 { h3: p("1. Entrepôts logistiques et chambres froides", "1. Logistics warehouses and cold storage", "1. Armazéns logísticos e câmaras frigoríficas"),
 p: p("Nécessité vitale pour la filière cajou, la pêche, l'agroalimentaire. Ticket : 150 000 à 800 000 €. Locataires B2B fidèles.", "Vital need for cashew, fishing, agri-food. Ticket: €150k to €800k. Loyal B2B tenants.", "Necessidade vital para o caju, a pesca, o agroalimentar. Ticket: 150 000 a 800 000 €. Arrendatários B2B fiéis.") },
 { h3: p("2. Immobilier commercial (retail & bureaux)", "2. Commercial real estate (retail & offices)", "2. Imobiliário comercial (retalho e escritórios)"),
 p: p("Bissau et Canchungo : besoin d'espaces qualitatifs pour banques, ONG, PME, commerces. Ticket : 100 000 à 500 000 €.", "Bissau and Canchungo: need for quality space for banks, NGOs, SMEs, retail. Ticket: €100k to €500k.", "Bissau e Canchungo: necessidade de espaços qualitativos para bancos, ONG, PME, comércios. Ticket: 100 000 a 500 000 €.") },
 { h3: p("3. Résidentiel intermédiaire", "3. Mid-market residential", "3. Residencial intermédio"),
 p: p("Petits immeubles 4-12 logements pour cadres locaux, diaspora en retour et expatriés. Ticket : 200 000 à 1 M€.", "Small 4-12 unit buildings for local executives, returning diaspora and expatriates. Ticket: €200k to €1M.", "Pequenos edifícios de 4-12 fogos para quadros locais, diáspora regressada e expatriados. Ticket: 200 000 a 1 M€.") },
 { h3: p("4. Hôtellerie milieu de gamme urbaine", "4. Urban mid-range hospitality", "4. Hotelaria urbana de gama média"),
 p: p("Structures 20-40 clés à Bissau pour délégations, ONG, businessmen. Marché en tension. Ticket : 400 000 à 1,5 M€.", "20-40 room properties in Bissau for delegations, NGOs, businesspeople. Tight market. Ticket: €400k to €1.5M.", "Estruturas de 20-40 chaves em Bissau para delegações, ONG, empresários. Mercado em tensão. Ticket: 400 000 a 1,5 M€.") },
 ],
 },
 defis: {
 title: p("Les défis à anticiper", "Challenges to anticipate", "Desafios a antecipar"),
 intro: p(
 "L'immobilier bissau-guinéen est encore artisanal. S'y installer suppose méthode et patience.",
 "Bissau-Guinean real estate is still artisanal. Entering it requires method and patience.",
 "O imobiliário guineense é ainda artesanal. Entrar exige método e paciência."
 ),
 items: p(
 [
 "Un cadastre en cours de modernisation, vérification du titre foncier indispensable.",
 "Des délais administratifs de permis de construire à intégrer au calendrier.",
 "Une chaîne d'approvisionnement en matériaux dépendante des importations (Portugal).",
 "Une main-d'œuvre BTP qualifiée à structurer localement.",
 "Un accès au financement bancaire local encore restreint pour les promoteurs internationaux.",
 ],
 [
 "A cadastre being modernised, verification of land title essential.",
 "Administrative delays for building permits to include in the schedule.",
 "A materials supply chain dependent on imports (Portugal).",
 "Qualified construction workforce to be structured locally.",
 "Local bank financing still restricted for international developers.",
 ],
 [
 "Um cadastro em modernização, verificação do título fundiário indispensável.",
 "Prazos administrativos de licenças de construção a integrar no calendário.",
 "Uma cadeia de abastecimento de materiais dependente das importações (Portugal).",
 "Uma mão-de-obra qualificada da construção a estruturar localmente.",
 "Um acesso ao financiamento bancário local ainda restrito para promotores internacionais.",
 ]
 ),
 closing: p(
 "Aucun de ces défis n'est bloquant. Tous s'anticipent au stade de l'étude, avec un partenaire local sérieux.",
 "None of these challenges is blocking. All can be anticipated at the study stage, with a serious local partner.",
 "Nenhum destes desafios é bloqueante. Todos se antecipam na fase de estudo, com um parceiro local sério."
 ),
 },
 pourquoi: {
 title: p("Un partenaire local pour un actif de long terme.", "A local partner for a long-term asset.", "Um parceiro local para um activo de longo prazo."),
 paragraphs: p(
 [
 "L'immobilier est le placement le plus dépendant de la connaissance locale. Titre foncier, autorités municipales, cabinets d'architecture, entrepreneurs, notaires : notre pôle Conseil en implantation orchestre l'ensemble.",
 "Nous accompagnons plus particulièrement les investisseurs de la diaspora, souvent seuls à distance, avec un pilotage rigoureux et transparent de la construction, de la location et de la maintenance.",
 ],
 [
 "Real estate is the most locally-dependent investment. Land title, municipal authorities, architecture firms, contractors, notaries: our Establishment Advisory orchestrates the whole.",
 "We particularly support diaspora investors, often alone at a distance, with rigorous and transparent management of construction, rental and maintenance.",
 ],
 [
 "O imobiliário é o investimento mais dependente do conhecimento local. Título fundiário, autoridades municipais, gabinetes de arquitectura, empreiteiros, notários: a nossa Consultoria de implantação orquestra o conjunto.",
 "Acompanhamos particularmente os investidores da diáspora, muitas vezes sós à distância, com um pilotagem rigoroso e transparente da construção, do arrendamento e da manutenção.",
 ]
 ),
 bullets: p(
 [
 "Identification et sécurisation du foncier",
 "Étude de marché locative précise",
 "Coordination architecte, entrepreneur, notaire",
 "Gestion locative et maintenance à distance",
 "Reporting mensuel pour investisseur international",
 ],
 [
 "Land identification and securing",
 "Precise rental market study",
 "Coordination architect, contractor, notary",
 "Remote rental management and maintenance",
 "Monthly reporting for international investors",
 ],
 [
 "Identificação e segurança do imóvel",
 "Estudo preciso do mercado de arrendamento",
 "Coordenação arquitecto, empreiteiro, notário",
 "Gestão de arrendamento e manutenção à distância",
 "Reporting mensal para investidor internacional",
 ]
 ),
 },
 download: {
 title: p(
 "Télécharger la note « Immobilier · Guinée-Bissau ».",
 "Download the brief « Real estate · Guinea-Bissau ».",
 "Descarregar a nota « Imobiliário · Guiné-Bissau »."
 ),
 body: p(
 "Une note préparée par NANDA SÁ : chiffres clés, segments d'investissement, cadre foncier et contacts utiles.",
 "A brief prepared by NANDA SÁ: key figures, investment segments, land framework and useful contacts.",
 "Uma nota preparada pela NANDA SÁ: dados-chave, segmentos de investimento, enquadramento fundiário e contactos úteis."
 ),
 pdfUrl: "/pdf/nanda-sa-note-immobilier.pdf",
 pdfFilename: "nanda-sa-note-immobilier.pdf",
 mailSubject: p("Téléchargement de la note « Immobilier · Guinée-Bissau »", "Download of the brief « Real estate · Guinea-Bissau »", "Descarga da nota « Imobiliário · Guiné-Bissau »"),
 mailBody: p(
 "Bonjour, je souhaite recevoir la note « Immobilier · Guinée-Bissau ». Merci de me tenir informé(e) des prochaines publications de NANDA SÁ.",
 "Hello, I would like to receive the brief « Real estate · Guinea-Bissau ». Please keep me informed of NANDA SÁ's next publications.",
 "Olá, gostaria de receber a nota « Imobiliário · Guiné-Bissau ». Por favor, mantenha-me informado(a) das próximas publicações da NANDA SÁ."
 ),
 },
 contact: {
 title: p("Parlons de votre projet immobilier.", "Let's talk about your real estate project.", "Falemos do seu projecto imobiliário."),
 body: p(
 "Promoteur, investisseur privé, diaspora, institution : décrivez votre intention, nous répondons personnellement sous 72 heures.",
 "Developer, private investor, diaspora, institution: describe your intention, we respond personally within 72 hours.",
 "Promotor, investidor privado, diáspora, instituição: descreva a sua intenção, respondemos pessoalmente em 72 horas."
 ),
 quote: p(
 "L'immobilier ne se construit pas contre le territoire. Il se construit avec lui.",
 "Real estate is not built against the territory. It is built with it.",
 "O imobiliário não se constrói contra o território. Constrói-se com ele."
 ),
 subject: p("Investir dans l'immobilier en Guinée-Bissau", "Invest in real estate in Guinea-Bissau", "Investir no imobiliário na Guiné-Bissau"),
 },
 ctas: ["Conseil"],
};

export default immobilier;
